import React from 'react';
import IconName from "../../svgLogo/SvgLogo";
import RangePrice from "./RangePrice";
import SelectionBox from "./SelectionBox";

const FilterOptions = () => {
    return (
        <div className="options-wrapper">
            <div id="filter-options" className="filter-options-wrapper d-none d-md-block container">
                <div className="row">
                    <div className="col-4 col-lg-3">
                        <div className="filter-box">
                            <div className="title"><span>جستجو در نتایج</span></div>
                            <input type="text" placeholder="نام محصول مورد نظر را بنویسید…"
                                   className="category-select ct-lg form-control position-relative"/>
                            <IconName name="search" className="icon position-absolute icon-search"/>
                        </div>
                    </div>
                    <div className="col-4 col-lg-3">
                        <SelectionBox/>
                    </div>
                    <div className="col-4 col-lg-3">
                        <div className="filter-box">
                            <div className="title d-flex justify-content-between align-items-end"><span>رنگ</span><span
                                className="delete delete-button-value-select">حذف</span></div>
                            <select className="category-select ct-lg form-select change-select">
                                <option value="default">تمام رنگ ها</option>
                                <option>قرمز</option>
                                <option>مشکی</option>
                                <option>بنفش</option>
                            </select>
                            <IconName name="expand_more" className="icon position-absolute more-icon"/>
                            <IconName name="palette" className="icon position-absolute icon-input"/>
                        </div>
                    </div>
                    <div className="col-4 col-lg-3 xmt-6 xmt-lg-0">
                        <RangePrice/>
                    </div>
                    <div className="col-4 col-lg-3 xmt-6">
                        <div className="filter-box">
                            <div className="title d-flex justify-content-between align-items-end">
                                <span>رزولوشن عکس</span><span
                                className="delete delete-button-value-select">حذف</span></div>
                            <select className="category-select ct-lg form-select change-select">
                                <option value="default">جستجوی نام</option>
                                <option>سامسونگ</option>
                                <option>شیائومی</option>
                                <option>هواوی</option>
                            </select>
                            <IconName name="expand_more" className="icon position-absolute more-icon"/>
                            <IconName name="camera_alt" className="icon position-absolute icon-input camera"/>
                        </div>
                    </div>
                    <div className="col-4 col-lg-3 xmt-6">
                        <div className="filter-box">
                            <div className="title d-flex justify-content-between align-items-end">
                                <span>فروشنده</span><span
                                className="delete delete-button-value-select">حذف</span></div>
                            <select className="category-select ct-lg form-select change-select">
                                <option value="default">نام فروشنده</option>
                                <option>سامسونگ</option>
                                <option>شیائومی</option>
                                <option>هواوی</option>
                            </select>
                            <IconName name="expand_more" className="icon position-absolute more-icon"/>
                            <IconName name="vendor" className="icon position-absolute icon-input"/>
                        </div>
                    </div>
                    <div className="col-4 col-lg-3 xmt-6">
                        <div className="filter-box">
                            <div className="title d-flex justify-content-between align-items-end">
                                <span>شبکه های ارتباطی</span><span
                                className="delete delete-button-value-select">حذف</span></div>
                            <select className="category-select ct-lg form-select change-select">
                                <option value="default">عنوان آیتم</option>
                                <option>سامسونگ</option>
                                <option>شیائومی</option>
                                <option>هواوی</option>
                            </select>
                            <IconName name="expand_more" className="icon more-icon position-absolute"/>
                            <IconName name="signal_cellular_alt" className="icon icon-input position-absolute"/>
                        </div>
                    </div>
                    <div className="col-5 col-lg-3 xmt-6">
                        <div className="switch-filter">
                            <div className="discount-filter d-flex align-items-center">
                                <span className="text">تخفیف دار ها</span>
                                <div className=" form-check form-switch">
                                    <input className="form-check-input discount-check change-select" type="checkbox"
                                           role="switch"/>
                                </div>
                            </div>
                            <div className="out-filter d-flex align-items-center">
                                <span className="text">فقط موجود</span>
                                <div className="form-check form-switch">
                                    <input className="form-check-input out-of-check change-select" type="checkbox"
                                           role="switch"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-block d-md-none">
                <div id="filter-wrapper-responsive"
                     className="options-wrapper-responsive">
                    <div className="title-options-responsive xmr-2 xmb-4">
                        <span>دسته بندی ها</span>
                    </div>
                    <div className="lists">
                        <ul className="list-unstyled">
                            <li className="nav-item">
                                <div className="toggle-list">
                                    <IconName name="loyalty" className="icon"/>
                                    <span>برند</span>
                                    <IconName name="add" className="icon position-absolute add-icon"/>
                                </div>
                                <ul className="list-unstyled">
                                    <li>
                                        <div className="form-check">

                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                اپل
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                سامسونگ
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                شیائومی
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                هوآوی
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                سونی
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                ال جی
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                اپل
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                ال جی
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                سونی
                                            </label>
                                        </div>
                                    </li>
                                </ul>
                            </li>
                            <li className="nav-item toggle-list">
                                <div className="toggle-list">
                                    <IconName name="palette" className="icon"/>
                                    <span>رنگ</span>
                                    <IconName name="add" className="icon position-absolute add-icon"/>
                                </div>
                                <ul className="list-unstyled">
                                    <li>
                                        <div className="form-check">

                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                قهوه ای
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                آبی
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                مشکی
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                سفید
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                صورتی
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                بنفش
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                زرد
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                آبی
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                قرمز
                                            </label>
                                        </div>
                                    </li>
                                </ul>
                            </li>
                            <li className="nav-item price-range-responsive">
                                <div className="toggle-list">
                                    <IconName name="monetization_on" className="icon"/>
                                    <span>محدوده قیمت</span>
                                    <IconName name="add" className="icon position-absolute add-icon"/>
                                </div>
                                <ul className="list-unstyled">
                                    <li>
                                        <RangePrice/>
                                    </li>
                                </ul>
                            </li>
                            <li className="nav-item">
                                <div className="toggle-list">
                                    <IconName name="camera_alt" className="icon"/>
                                    <span>رزولوشن عکس</span>
                                    <IconName name="add" className="icon position-absolute add-icon"/>
                                </div>
                                <ul className="list-unstyled">
                                    <li>
                                        <div className="form-check">

                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                اپل
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                سامسونگ
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                شیائومی
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                هوآوی
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                سونی
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                ال جی
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                اپل
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                ال جی
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                سونی
                                            </label>
                                        </div>
                                    </li>
                                </ul>
                            </li>
                            <li className="nav-item">
                                <div className="toggle-list">
                                    <IconName name="vendor" className="icon"/>
                                    <span>فروشنده</span>
                                    <IconName name="add" className="icon position-absolute add-icon"/>
                                </div>
                                <ul className="list-unstyled">
                                    <li>
                                        <div className="form-check">

                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                اپل
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                سامسونگ
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                شیائومی
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                هوآوی
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                سونی
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                ال جی
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                اپل
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                ال جی
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                سونی
                                            </label>
                                        </div>
                                    </li>
                                </ul>
                            </li>
                            <li className="nav-item">
                                <div className="toggle-list">
                                    <IconName name="adb" className="icon"/>
                                    <span>سیستم عامل</span>
                                    <IconName name="add" className="icon position-absolute add-icon"/>
                                </div>
                                <ul className="list-unstyled">
                                    <li>
                                        <div className="form-check">

                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                اپل
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                سامسونگ
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                شیائومی
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                هوآوی
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                سونی
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                ال جی
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                اپل
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                ال جی
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                سونی
                                            </label>
                                        </div>
                                    </li>
                                </ul>
                            </li>
                            <li className="nav-item">
                                <div className="toggle-list">
                                    <IconName name="signal_cellular_alt" className="icon"/>
                                    <span>شبکه‌های ارتباطی</span>
                                    <IconName name="add" className="icon position-absolute add-icon"/>
                                </div>
                                <ul className="list-unstyled">
                                    <li>
                                        <div className="form-check">

                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                اپل
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                سامسونگ
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                شیائومی
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                هوآوی
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                سونی
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                ال جی
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                اپل
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                ال جی
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                <input className="form-check-input" type="checkbox" value=""/>
                                                سونی
                                            </label>
                                        </div>
                                    </li>
                                </ul>
                            </li>
                            <li className="nav-item action-filter">
                                <div className="toggle-list">
                                    <IconName name="refresh" className="icon"/>
                                    <span className="text">حذف</span>
                                    <span className="actions position-absolute add-icon">اعمال</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FilterOptions;
